import { render, staticRenderFns } from "./SecReleaseNumber.vue?vue&type=template&id=9d273034"
import script from "./SecReleaseNumber.vue?vue&type=script&lang=js"
export * from "./SecReleaseNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports